import React from 'react';
import logo from '../../../Assets/image.png';
import Alogo from '../../../Assets/Alphalogo.png';
import styles from './Login.module.css';

const LoginCard = ({ children }) => {
  return (
    <div className={styles.loginCard}>
      <div className={styles.cardHeader}>
        
        <div className={styles.logoRow}>
          <img
            src={logo}
            alt="SclinEDC Logo"
            className={styles.logoImage}
          />

         

          <img
            src={Alogo}
            alt="AlphaMD Logo"
            className={styles.logoImage}
          />
        </div>

        <h3 className={styles.cardTitle}>Sign in</h3>
      </div>

      {children}
    </div>
  );
};

export default LoginCard;
